import { render, staticRenderFns } from "./PersonProfileNotesRow.vue?vue&type=template&id=28a642dc&scoped=true&"
import script from "./PersonProfileNotesRow.vue?vue&type=script&lang=js&"
export * from "./PersonProfileNotesRow.vue?vue&type=script&lang=js&"
import style0 from "./PersonProfileNotesRow.vue?vue&type=style&index=0&id=28a642dc&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28a642dc",
  null
  
)

export default component.exports